"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTitle4 = void 0;
var _createText = require("./createText");
const TextTitle4 = (0, _createText.createText)('title4');
exports.TextTitle4 = TextTitle4;